/* eslint-disable react/require-default-props */
/* eslint no-unused-expressions: "off" */
import { AxiosError } from 'axios';
import { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ErrorInfo, PsNote } from '../../../../../api/model';
import { usePostPsNoteAdd } from '../../../../../api/ps-notes/ps-notes';
import { useDefaultOptions } from '../../../../../hooks/api';
import { formatDate, truncateDate } from '../../../ps/index/PsListCommmon';

type Props = {
  chapterId: number;
  psDerivationId: number;
  psNote: PsNote;
  onClose: () => void;
  psNoteRefetch: () => void;
};
function PsNoteForm({ chapterId, psDerivationId, psNote, onClose, psNoteRefetch }: Props) {
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm<PsNote>({
    defaultValues: {
      ps_id: psNote.ps_id,
      chapter_id: chapterId,
      description: psNote.description,
    },
  });

  const {
    t,
    i18n: { language },
  } = useTranslation();
  const options = useDefaultOptions(language);

  const { mutateAsync, isSuccess } = usePostPsNoteAdd<AxiosError<ErrorInfo>, unknown>(options);

  /**
   * 保存処理
   */
  const onSubmit = async () => {
    await handleSubmit((data: PsNote) => {
      void mutateAsync({
        data,
      });
    })();
    // 改廃案メモ一覧の再読込み
    psNoteRefetch();
  };

  const date = useMemo(() => formatDate(truncateDate(new Date()), 'YYYY/MM/DD'), []);

  useEffect(() => {
    if (isSuccess) {
      onClose();
      reset();
    }
  }, [isSuccess, onClose, reset]);

  if (!psDerivationId) return <div>{t('PS情報がありません')}</div>;

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="popupfr mtsp popupfr865">
        <div className="pop-tablefr1">
          <div>
            <table>
              <tbody>
                <tr>
                  <th>{t('PS管理No. ')}</th>
                  <td>{psNote.ps_no}</td>
                </tr>
                <tr>
                  <th>{t('登録日')}</th>
                  <td>{date}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div>
            <table>
              <tbody>
                <tr>
                  <th>{t('該当章')}</th>
                  <td>{psNote.chapter_name}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="formarea1 fa2_confreq">
          <label htmlFor="description">{t('改訂内容')}</label>
          <textarea id="description" rows={5} cols={33} {...register('description')} />
        </div>

        <div className="btnfr btnfr2w mb0">
          <div>
            <span className="btn2 btnbg-g">
              <span className="modal-close2" onClick={onClose}>
              {t('キャンセル')}
              </span>
            </span>
            <span>
              <input type="submit" id="" name="" value={t('登録').toString()} className="btn1 lsp1" />
            </span>{' '}
          </div>
        </div>
      </div>
    </form>
  );
}

export { PsNoteForm };
